
import { useEffect, useState, type JSX } from 'react';
import { useParams } from 'react-router-dom';

import Editor, { type NoteResponse } from '@components/Editor';
import Page404 from './Page404';
import Page403 from './Page403';

export default function SharedNote(): JSX.Element {
  const { '*': id } = useParams<{ '*'?: string }>();
  const [editorHeaderHeight, setEditorHeaderHeight] = useState(41);

  useEffect(() => {
    const recalculateScrollSize = () => {
      const header = document.getElementsByClassName('ql-toolbar')[0];
      setEditorHeaderHeight(header?.getBoundingClientRect()?.height || 0);
    };

    const onWindowResize = () => {
      recalculateScrollSize();
    };

    const timeoutId = window.setTimeout(recalculateScrollSize, 100);
    window.addEventListener('resize', onWindowResize);

    return () => {
      window.removeEventListener('resize', onWindowResize);
      window.clearTimeout(timeoutId);
    };
  }, []);

  const onDataLoaded = (note: NoteResponse) => {
    document.title = 'Notes - ' + note.name;
  };

  return (
    <>
      <style>
        {`#snow-container .ql-container {  height: calc(100vh - ${editorHeaderHeight}px) !important; height: calc(var(--vh, 1vh) * 100 - ${editorHeaderHeight}px)!important; }`}
      </style>
      <div className="shared-note-wrapper">
        <Editor
          noteId={id || ''}
          notFoundView={Page404}
          accessDeniedView={Page403}
          sharedView
          onDataLoaded={onDataLoaded}
        />
      </div>
    </>
  );
}